export default function NoMatch() {
  return (
    <div className="mt-5">
      <p className="lead fw-bold text-center display-1">Page not found</p>
    </div>
  );
}
